import { useMutation, useQuery } from "@tanstack/react-query";

import { QUERY_KEYS } from "@/api/constants";
import type { LoginFormData } from "@/modules/LoginForm/types";

import { authApi } from "./authApi";
import type { NewPasswordPayload, ResetPayload } from "./types";

export const useLoginMutation = () => {
  return useMutation({
    mutationFn: (data: LoginFormData) => {
      return authApi.postLogin(data);
    },
  });
};

export const useLogoutAdminMutation = () => {
  return useMutation({
    mutationFn: ({ token }: { token: string }) => {
      return authApi.postLogout(token);
    },
  });
};

export const useCheckTeamInviteTokenQuery = (token: string, options = {}) =>
  useQuery({
    queryKey: [QUERY_KEYS.checkInviteTeamToken, token],
    queryFn: () => authApi.checkInviteTeamToken(token),
    retry: false,
    enabled: !!token,
    ...options,
  });

export const useForgotPasswordAdminMutation = () => {
  return useMutation({
    mutationFn: (data: ResetPayload) => {
      return authApi.postForgotPassword(data);
    },
  });
};

export const useCheckAdminResetPasswordTokenQuery = (
  token: string,
  options = {}
) =>
  useQuery({
    queryKey: [QUERY_KEYS.checkResetPasswordAdminToken, token],
    queryFn: () => authApi.checkResetPasswordAdminToken(token),
    retry: false,
    enabled: !!token,
    ...options,
  });

export const useSendNewPasswordMutation = () => {
  return useMutation({
    mutationFn: ({
      token,
      data,
    }: {
      token: string;
      data: NewPasswordPayload;
    }) => {
      return authApi.sendNewPassword(token, data);
    },
  });
};
